function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 7H9a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V9a2 2 0 00-2-2zM9 5a4 4 0 00-4 4v12a4 4 0 004 4h12a4 4 0 004-4V9a4 4 0 00-4-4H9z",
  fill: "currentColor"
});
function SvgUncheckedBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 30",
    fill: "none"
  }, props), _ref);
}
export default __webpack_public_path__ + "fonts/unchecked-box-0327a068ec0ed262e385d98977aef91e.svg";
export { SvgUncheckedBox as ReactComponent };